import { Component, ViewEncapsulation } from '@angular/core';
import { SpaContext } from '../../Classes/spacontext';
import { SpaEventService } from '../../Services/spaEvents.service';
import { ScheduledDataService } from '../../Services/scheduled-data';
import { UnitService } from '../../Services/api/v2/Units/units.service';
import { WebContentButtonsService } from '../../Services/api/v2/Units/webContentButtons.service';
import { AuthContextService } from '../../Services/authContext.service';
import { FlexiblePatientButtonsService } from '../../Services/flexible_patient_buttons.service/mod';

import { LocationSelectorService } from '@services/location_selector.service';
import { sharedResolution } from '../../../../src/shared_resolution';

@Component({
	standalone: false,
	templateUrl: '../../ViewHtml/Index/IndexMain.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['../../Css/Views/Index/IndexMain.scss'],
})
export class IndexComponent {
	title: string = '';
	body: string = '';
	unit: any;
	selectValues: Array<any>;
	model: any = { Phone: '3' };
	theme: any;
	myCasesNotificationCount = 0;
	doors: Array<any> = [];

	private _subscribers = [];

	constructor(
		public readonly flexiblePatientButtonsService: FlexiblePatientButtonsService,
		public spaContext: SpaContext,
		public authContextService: AuthContextService,
		private _unitController: UnitService,
		private _spaEventService: SpaEventService,
		private _scheduledDataService: ScheduledDataService,
		public webContentButtonsService: WebContentButtonsService,
	) {
		this.unit = spaContext.unitConfig.Unit;
		this.theme = spaContext.unitConfig.Theme;
	}

	ngOnInit() {
		this.flexiblePatientButtonsService.fetchComponents();

		this._unitController.getText(['View_Index_Title', 'View_Index_Body']).subscribe(
			(response) => {
				this.title = response.data.View_Index_Title;
				this.body = response.data.View_Index_Body;
			},
			(err) => {
				console.log(err);
			},
		);

		const subscriber1 = this._scheduledDataService.onGetCases.subscribe((caseList) => {
			const issues = caseList.map((c) => c.UnhandledIssues.length).reduce((a, b) => a + b, 0);
			this.myCasesNotificationCount = issues;
		});
		this._subscribers.push(subscriber1);
	}

	isInstanceOf(a: any, b: any) {
		return a instanceof b;
	}

	ngOnDestroy() {
		this._subscribers.forEach((s) => s.unsubscribe());
	}

	signIn() {
		const locationSelectorService = sharedResolution.resolve(LocationSelectorService);
		this._spaEventService.onSignInRequired.emit({
			leave: false,
			target: '/' + locationSelectorService.location.route,
			reason: null,
		});
	}
}
